import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import itemsReducer from './slices/itemsSlice';
import cartReducer from './slices/cartSlice';
import ordersReducer from './slices/ordersSlice';
import pointsReducer from './slices/pointsSlice';
import giftCardsReducer from './slices/giftCardsSlice';
import negotiationsReducer from './slices/negotiationsSlice';
import auraReducer from './slices/auraSlice';
import favoritesReducer from './slices/favoritesSlice';
import subscriptionsReducer from './slices/subscriptionsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    items: itemsReducer,
    cart: cartReducer,
    orders: ordersReducer,
    points: pointsReducer,
    giftCards: giftCardsReducer,
    negotiations: negotiationsReducer,
    aura: auraReducer,
    favorites: favoritesReducer,
    subscriptions: subscriptionsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});
